import Vue from "vue";
import VueRouter from "vue-router";
import MainPage from "./../src/components/MainPage.vue";
import TaskList from "./../src/components/TaskList.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", component: MainPage },
  { path: "/tasks", component: TaskList },
];

const router = new VueRouter({
  routes,
});

export default router;